export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11378.3ec49781.jpg";